import { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '@/App';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AuthCallback() {
  const { setUser } = useContext(AuthContext);
  const navigate = useNavigate();

  useEffect(() => {
    const processAuth = async () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      console.log('Auth Callback - Full hash:', hash);
      console.log('Auth Callback - Session ID:', sessionId);

      if (!sessionId) {
        console.error('No session_id found in URL');
        alert('Authentication failed: No session ID received');
        navigate('/');
        return;
      }

      try {
        console.log('Calling backend with session_id:', sessionId);
        const response = await axios.post(
          `${API}/auth/session`,
          { session_id: sessionId },
          { withCredentials: true }
        );
        
        console.log('Auth successful, user:', response.data.user);
        
        // Store session token in localStorage for mobile Safari compatibility
        if (response.data.session_token) {
          localStorage.setItem('session_token', response.data.session_token);
          console.log('Session token stored in localStorage');
        }
        
        setUser(response.data.user);
        
        // Clean URL and redirect
        window.history.replaceState(null, '', '/auth/callback');
        navigate('/');
      } catch (error) {
        console.error('Auth error details:', error.response?.data || error.message);
        alert(`Authentication failed: ${error.response?.data?.detail || error.message}`);
        navigate('/');
      }
    };

    processAuth();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#8B5A3C]">
      <div className="text-center" data-testid="auth-loading">
        <div className="text-[#F4E4C1] text-2xl mb-4">Authenticating...</div>
        <div className="w-16 h-16 border-4 border-[#D4A574] border-t-transparent rounded-full animate-spin mx-auto"></div>
      </div>
    </div>
  );
}